package org.moxultimate.topwithmox.components.texts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.vw
import org.moxultimate.topwithmox.theme.FontFamily
import org.moxultimate.topwithmox.theme.MaxTitleFontSize
import org.moxultimate.topwithmox.theme.MinTitleFontSize
import org.moxultimate.topwithmox.theme.WhiteTextColor

/**
 * TitleText
 * Responsive bold section heading. When [gradient] is true the Mox rainbow gradient is applied
 * instead of [color]; the [color] param is ignored in that case.
 *
 * @param title    Text to display.
 * @param color    Solid fill color used when [gradient] is false.
 * @param gradient When true, applies the Mox linear gradient instead of [color].
 * @param modifier Additional modifiers (alignment, padding, etc.).
 */
@Composable
fun TitleText(
    title: String,
    color: Color = WhiteTextColor,
    gradient: Boolean = false,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = title,
        modifier = modifier
            .then(if (gradient) Modifier.moxTextGradient() else Modifier.color(color))
            .fontFamily(FontFamily)
            .fontSize(clamp(min = MinTitleFontSize, value = 2.vw, max = MaxTitleFontSize))
            .fontWeight(FontWeight.Bold)
    )
}